import './styles.css';

export const AnimatedBattery = () => {
  return (
    <div className='AnimatedBattery text-green-600' />
  );
}